import { apiCall } from './api';

export const getEventLog = async (filters) => {
  let endpoint = '/comptabilite/compliance/event-log';
  const params = [];
  if (filters) {
    if (filters.startDate) params.push(`startDate=${filters.startDate}`);
    if (filters.endDate) params.push(`endDate=${filters.endDate}`);
    if (filters.eventType) params.push(`eventType=${filters.eventType}`);
    if (filters.category) params.push(`eventCategory=${filters.category}`);
    if (filters.userId) params.push(`userId=${filters.userId}`);
    if (filters.criticalOnly) params.push(`isCritical=1`);
  }
  if (params.length) endpoint += `?${params.join('&')}`;
  const result = await apiCall(endpoint);
  return result.events || result.data || [];
};

export const getEventLogStats = async (startDate, endDate) => {
  const result = await apiCall(`/comptabilite/compliance/event-log/stats?startDate=${startDate}&endDate=${endDate}`);
  return result.data || result;
};

export const logEvent = async (eventData) => {
  const result = await apiCall('/comptabilite/compliance/event-log', 'POST', eventData);
  return result.data || result;
};

export const getVersions = async () => {
  const result = await apiCall('/comptabilite/compliance/versions');
  return result.versions || result.data || [];
};

export const addVersion = async (versionData) => {
  const payload = {
    versionNumber: versionData.version_number || versionData.versionNumber,
    versionName: versionData.version_name || versionData.versionName || versionData.version_number,
    releaseDate: versionData.release_date || versionData.releaseDate,
    installedBy: versionData.installed_by || versionData.installedBy,
    description: versionData.description,
    changelog: versionData.changelog,
  };
  const result = await apiCall('/comptabilite/compliance/versions', 'POST', payload);
  return result.data || result;
};

export const getParameterHistory = async (filters) => {
  let endpoint = '/comptabilite/compliance/parameters';
  const params = [];
  if (filters) {
    if (filters.parameterType) params.push(`parameterType=${filters.parameterType}`);
    if (filters.startDate) params.push(`startDate=${filters.startDate}`);
    if (filters.endDate) params.push(`endDate=${filters.endDate}`);
  }
  if (params.length) endpoint += `?${params.join('&')}`;
  const result = await apiCall(endpoint);
  return result.history || result.data || [];
};

export const getParameterComparison = async () => {
  const result = await apiCall('/comptabilite/compliance/parameters/comparison');
  const items = result.customParameters || result.data || [];
  return items.map((p) => ({
    id: p.key || p.parameter_key,
    parameter_name: p.name || p.parameter_name,
    parameter_type: p.type || p.parameter_type,
    current_value: p.current_value ?? (typeof p.currentValue === 'object' ? JSON.stringify(p.currentValue) : p.currentValue),
    default_value: p.default_value ?? (typeof p.defaultValue === 'object' ? JSON.stringify(p.defaultValue) : p.defaultValue),
    last_modified_at: p.lastModified || p.last_modified_at || p.change_date,
    last_modified_by: p.modifiedBy || p.last_modified_by || p.changed_by,
    description: p.description || '',
  }));
};

export const getBackupLog = async () => {
  const result = await apiCall('/comptabilite/compliance/backups');
  return result.backups || result.data || [];
};

export const logBackup = async (backupData) => {
  const result = await apiCall('/comptabilite/compliance/backups', 'POST', backupData);
  return result.data || result;
};
